import Map from '../Shared/Map/index';
import { TranslationService } from '../../services/translation.service';
import { ConfigurationService } from '../../services/configuration.service';
import RetailerMarker from './markers/RetailerMarker';
import './style.scss';

function RetailerMap() {
  const retailerPageLatitude = ConfigurationService.get('retailerpage.maplatitude');
  const retailerPageLongitude = ConfigurationService.get('retailerpage.maplongitude');
  const name = ConfigurationService.get('retailerpage.storename');
  if (!retailerPageLatitude || !retailerPageLongitude || !name) {
    throw new Error('Retailer page latitude and longitude are required');
  }

  const latitude = parseFloat(retailerPageLatitude);
  const longitude = parseFloat(retailerPageLongitude);

  return (
    <Map
      ariaLabel={`${TranslationService.get('retailerpage.map.mapof')} ${name}`}
      className="retailer-page__map"
      markers={[<RetailerMarker key={`${latitude}-${longitude}`} coordinates={{ latitude, longitude }} name={name} />]}
      center={[latitude, longitude]}
    />
  );
}

export default RetailerMap;
